/**
 * HTTP 层错误 ( fetch / axios 等均可复用 )
 */

export class HttpError extends Error {
  /**
   * @param {string} message
   * @param {number} [status]
   */
  constructor(message, status) {
    super(message)
    this.name = 'HttpError'
    this.status = status
  }

  static isHttpError(err) {
    return err instanceof HttpError
  }

  static isUnauthorized(err) {
    return err instanceof UnauthorizedError
      || (HttpError.isHttpError(err) && err.status === 401)
  }

  static isStatus(err, status) {
    return HttpError.isHttpError(err) && err.status === status
  }

  /**
   * 从 JSON body + HTTP status 构造；401 返回 UnauthorizedError
   * @param {Record<string, unknown>} [data]
   * @param {number} status
   * @param {string} [fallback]
   */
  static fromPayload(data, status, fallback = '请求失败') {
    const message = data?.error || data?.message || `${fallback} (${status})`
    if (status === 401) return new UnauthorizedError(String(message))
    return new HttpError(String(message), status)
  }
}

export class UnauthorizedError extends HttpError {
  constructor(message = '未授权') {
    super(message, 401)
    this.name = 'UnauthorizedError'
  }
}
